import { createReducer, on } from '@ngrx/store';
import {
  AchActions,
  CheckActions,
  InternalTransferActions,
  InternalTransfersActions,
  ReviewPageActions,
  TransactionFormActions,
  WireActions,
} from '../actions';
import { TwePopup } from '../models/internal-transfer/TwePopup';
import { AccountInfoActions } from '../../account-info-header/actions';

export const twePopupKey = 'twePopupInfo';

export interface State extends TwePopup { }

export const initialTwePopupState: State = {
  openTwePopup: false,
  totalRows: 0,
  isFirstTimeDistribution: false,
  isTweOnFile: false,
  isNonNAState: false,
  existingAccountFederalTaxWithholdingElection: false,
  existingAccountStateTaxWithholdingElection: false,
  existingAccountFedTaxRate: 0,
  existingAccountStateTaxRate: 0,
  fedTaxRateUserEntered: 0,
  stateTaxRateUserEntered: 0,
  accountDetails: {
    aprOverflowIn: false,
    sloaOverflowInd: false,
    recurringOverflowInd: false,
    returnCode: '',
    errorCode: 0,
    errorMessage: '',
    errorDetails: '',
    totalRowsApr: 0,
    totalRowsSloa: 0,
    totalRowsRecurring: 0,
    hasRecurringTxn: false,
    hasSloaTxn: false,
    accountLevelInfo: {
      trustAccountIndicator: false,
      hasWfpaRoleIndicator: false,
      hasNdfaRoleIndicator: false,
      hasLpfaRoleIndicator: false,
      masterSubAssociationIndicator: false,
      accountRegistrationValidIndicator: false,
      checkRestrictionIndicator: false,
      journalRestrictionIndicator: false,
      moneylinkRestrictionInIndicator: false,
      moneylinkRestrictionOutIndicator: false,
      validBirthDateIndicator: false,
      validTaxpayerIdIndicator: false,
      validRcFrmBptIndicator: false,
      cashMoneyMarketFundAmount: 0,
      availableToBorrowAmount: 0,
      rmdEligibleIndicator: false,
      rmdActiveRecurringIndicator: false,
      customer592Date: '',
      customer702Date: '',
      rmdAnnualCalcAmount: 0,
      rmdAnnualPaidYearToDateAmount: 0,
      rmdAnnualRemainAmount: 0,
    },
    cashieringRequestAprs: [],
    recurringRequests: [],
    sloaRequests: [],
  },
  regShortName: '',
};

export const reducer = createReducer(
  initialTwePopupState,
  on(
    TransactionFormActions.callInternalTransferVerify,
    (_, action) => {
      return initialTwePopupState;
    }
  ),
  on(InternalTransferActions.verifyCallSuccessful, (state, action) => {
    const { response } = action;
    return {
      ...state,
      ...response.twePopup,
    };
  }),
  on(InternalTransfersActions.verifyListCallSuccessful, (state, action) => {
    const { response } = action;
    return {
      ...state,
      ...response.included[0].attributes.twePopup,
    };
  }),
  on(CheckActions.verifyCallSuccessful, (state, action) => {
    const { checkVerifyResponse } = action;
    return {
      ...state,
      ...checkVerifyResponse.twePopup,
    };
  }),
  on(WireActions.verifyV3CallSuccessful, (state, { response }) => {
    return {
      ...state,
      ...response.twePopup,
    };
  }),
  on(
    ReviewPageActions.cancelClicked,
    TransactionFormActions.cancelClicked,
    (_) => {
      return initialTwePopupState;
    }
  ),
  on(AchActions.verifyCallSuccessful, (state, {response}) => {
    return response.twePopup;
  }),
  on(AccountInfoActions.verifyTaxWithholdingsSuccess, (state, {response}) => {
    return {
      ...state,
      ...response.twePopup,
    };
  })
);
